import React, { useEffect, useState } from "react";

// APP COMPONENTS
import DriversService from "../../api/driver";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const DriverFilter = ({ selectedValue, onFilterChange }) => {
  const [drivers, setDrivers] = useState([]);

  useEffect(() => {
    loadData().then((r) => r);
  }, []);

  const loadData = async () => {
    const res = await DriversService.getDrivers();

    const driversTreated = res.data.map((driver) => {
      return {
        label: driver.name,
        value: driver.driver_id,
      };
    });
    driversTreated.unshift({
      label: "Todos",
      value: "ALL",
    });

    setDrivers(driversTreated);
  };

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="driver-values"
      options={drivers}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Entregador"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

DriverFilter.displayName = "Motorista";

export default DriverFilter;
